export const COLOR_POSITIVE = "#fdbd49";
export const COLOR_DEATHS = "#d62d20";
export const COLOR_TESTED = "#6ea7ef";
export const COLOR_POSITIVE_DARK = "#a16801";
export const COLOR_DEATHS_DARK = "#6b1610";
export const COLOR_TESTED_DARK = "#114f9d";
export const COLOR_BED_VENT_COVID = "#002e6c";
export const COLOR_BED_VENT_NON_COVID = "#77787b";
export const COLOR_BED_VENT_AVAILABLE = "#008744";
export const COLOR_BED_VENT_UNAVAILABLE = "#808080";
export const COLOR_TOTAL_DAILY_CASES = "#fdbd49";
export const COLOR_TOTAL_DAILY_DEATHS = "#d62d20";
export const COLOR_TOTAL_DAILY_TESTED = "#6ea7ef";
export const POSITIVE_TEST_RATE = "#A196D4";
export const POSITIVE_TEST_RATE_MOVING = "#534E6E";
export const POSITIVE_TEST_RATE_DARK = "#6d5bbc";
export const INFO_COLOR = "#0A9CA1";
export const BASE_COLOR = "#2a4d87";
export const STUDENT = "#ffa600";
export const TEACHER = "#6db353";
export const STAFF = "#8245A1";
